var utils = {};
var isMobile= false;
utils.navigation = {
	data: {
		"main": [{
			"id": "community",
			"title": "圈子",
			"list": [{
				"tab": "视频教程",
				"item": [{
					"name": "慕课网",
					"href": "http://www.imooc.com/",
					"title": "慕课网是一个IT视频网站"
				}, {
					"name": "极客学院",
					"href": "http://www.jikexueyuan.com/",
					"title": ""
				}]
			}, {
				"tab": "前端知识",
				"item": [{
					"name": "菜鸟教程",
					"href": "http://www.runoob.com/",
					"title": ""
				}, {
					"name": "w3school",
					"href": "http://www.w3school.com.cn/",
					"title": ""
				}]
			}]
		}, {
			"id": "html",
			"title": "CSS/HTML",
			"list": [{
				"tab": "CSS",
				"item": [{
					"name": "CSS3参考手册",
					"href": "http://css.doyoe.com/",
					"title": ""
				}, {
					"name": "浏览器Hack大全",
					"href": "http://browserhacks.com/",
					"title": ""
				}, {
					"name": "ie默认css",
					"href": "http://www.iecss.com/",
					"title": ""
				}, {
					"name": "Animate动画库",
					"href": "http://daneden.github.io/animate.css/",
					"title": ""
				}]
			}, {
				"tab": "HTML",
				"item": [{
					"name": "HTML5中国",
					"href": "http://www.html5cn.org/",
					"title": ""
				}, {
					"name": "HTML5基地",
					"href": "http://html5.360.cn/",
					"title": ""
				}, {
					"name": "5+App",
					"href": "http://ask.dcloud.net.cn/explore/",
					"title": ""
				}]
			}]
		}, {
			"id": "blog",
			"title": "博客社区",
			"list": [{
				"tab": "社区",
				"item": [{
					"name": "Github",
					"href": "https://github.com/",
					"title": ""
				}, {
					"name": "SegmentFault",
					"href": "https://segmentfault.com/",
					"title": ""
				}, {
					"name": "W3Cfuns",
					"href": "http://www.w3cfuns.com/",
					"title": ""
				}, {
					"name": "CSDN",
					"href": "http://blog.csdn.net/web/index.html",
					"title": ""
				}, {
					"name": "博客园",
					"href": "http://www.cnblogs.com/",
					"title": ""
				}, {
					"name": "伯乐在线",
					"href": "http://web.jobbole.com/",
					"title": ""
				}, {
					"name": "开源中国",
					"href": "http://www.oschina.net/",
					"title": ""
				}]
			}, {
				"tab": "博客",
				"item": [{
					"name": "阮一峰",
					"href": "http://www.ruanyifeng.com/home.html",
					"title": ""
				}]
			}]
		}, {
			"id": "js",
			"title": "JavaScript",
			"list": [{
				"tab": "原生开发",
				"item": [{
					"name": "MDN(JavaScript)",
					"href": "https://developer.mozilla.org/zh-CN/docs/Web/JavaScript",
					"title": ""
				}, {
					"name": "JavaScript 秘密花园",
					"href": "http://bonsaiden.github.io/JavaScript-Garden/zh/",
					"title": ""
				}, {
					"name": "JavaScript资源大全",
					"href": "https://github.com/jobbole/awesome-javascript-cn",
					"title": ""
				}]
			}, {
				"tab": "JavaScript库",
				"item": [{
					"name": "JQuery",
					"href": "http://jquery.com/",
					"title": ""
				}, {
					"name": "Zepto",
					"href": "http://www.css88.com/doc/zeptojs_api/#ajax",
					"title": ""
				}, {
					"name": "AngularJS",
					"href": "https://angularjs.org/",
					"title": ""
				}, {
					"name": "KISSY",
					"href": "http://docs.kissyui.com/",
					"title": ""
				}, {
					"name": "ExtJS",
					"href": "http://extjs.org.cn/",
					"title": ""
				}]
			}, {
				"tab": "JQuery",
				"item": [{
					"name": "jQuery中文文档",
					"href": "http://www.jquery123.com/",
					"title": ""
				}, {
					"name": "JQuery插件库",
					"href": "http://www.jq22.com/",
					"title": ""
				}, {
					"name": "JQuery之家",
					"href": "http://www.htmleaf.com/",
					"title": ""
				}, {
					"name": "jQuery Transit 动画库",
					"href": "http://www.htmleaf.com/jQuery/Layout-Interface/201501281289.html",
					"title": ""
				}, {
					"name": "JQueryFuns",
					"href": "http://www.jqueryfuns.com/",
					"title": ""
				}, {
					"name": "FullPage.js",
					"href": "http://www.dowebok.com/77.html",
					"title": ""
				}, {
					"name": "富文本编辑器",
					"href": "http://www.biaodianfu.com/editor.html",
					"title": ""
				}]
			}]
		}, {
			"id": "mobile",
			"title": "移动端/响应式",
			"list": [{
				"tab": "移动端",
				"item": [{
					"name": "Ionic",
					"href": "http://www.ionic.wang/",
					"title": ""
				}, {
					"name": "JQueryMobile",
					"href": "http://jquerymobile.com/",
					"title": ""
				}, {
					"name": "5+App",
					"href": "http://www.dcloud.io/docs/api/index.shtml",
					"title": ""
				}, {
					"name": "Framework7",
					"href": "http://framework7.io/",
					"title": ""
				}, {
					"name": "FrozenUI",
					"href": "http://frozenui.github.io/",
					"title": ""
				}, {
					"name": "Mobile Angular UI",
					"href": "http://mobileangularui.com/",
					"title": ""
				}]
			}, {
				"tab": "响应式",
				"item": [{
					"name": "Bootstrap",
					"href": "http://www.bootcss.com/",
					"title": ""
				}, {
					"name": "Material-UI",
					"href": "http://www.material-ui.com/#/",
					"title": ""
				}, {
					"name": "UIkit",
					"href": "http://getuikit.com/",
					"title": ""
				}, {
					"name": "AmazeUI",
					"href": "http://amazeui.org/",
					"title": ""
				}]
			}, {
				"tab": "模块化",
				"item": [{
					"name": "CommonJS",
					"href": "http://www.commonjs.org/",
					"title": ""
				}, {
					"name": "Sea.js",
					"href": "http://seajs.org/docs/",
					"title": ""
				}, {
					"name": "RequireJS",
					"href": "http://requirejs.org/",
					"title": ""
				}, {
					"name": "NodeJS",
					"href": "https://nodejs.org/en/",
					"title": ""
				}]
			}]
		}, {
			"id": "tool",
			"title": "实用工具",
			"list": [{
				"tab": "CSS",
				"item": [{
					"name": "css3动画工具",
					"href": "http://isux.tencent.com/css3/tools.html",
					"title": ""
				}]
			}, {
				"tab": "编辑器",
				"item": [{
					"name": "Sublime Text",
					"href": "http://www.sublimetext.com/",
					"title": ""
				}, {
					"name": "HBuilder",
					"href": "http://www.dcloud.io/",
					"title": ""
				}, {
					"name": "Atom",
					"href": "https://atom.io/",
					"title": ""
				}, {
					"name": "WebStorm",
					"href": "https://www.jetbrains.com/webstorm/",
					"title": ""
				}, {
					"name": "Dreamweaver",
					"href": "http://www.adobe.com/cn/products/dreamweaver.html",
					"title": ""
				}]
			}, {
				"tab": "在线编辑器",
				"item": [{
					"name": "RunJS",
					"href": "http://runjs.cn/",
					"title": "在线编辑、展示、分享、交流你的 JavaScript 代码"
				}, {
					"name": "Online IDE",
					"href": "http://www.compileonline.com/",
					"title": ""
				}, {
					"name": "CODEPEN",
					"href": "http://codepen.io/",
					"title": ""
				}, {
					"name": "JS Bin",
					"href": "http://jsbin.com/?html,output",
					"title": ""
				}, {
					"name": "CSSdeck",
					"href": "http://cssdeck.com/",
					"title": ""
				}]
			}, {
				"tab": "格式化",
				"item": [{
					"name": "Tool 在线工具",
					"href": "http://tool.lu/",
					"title": ""
				}, {
					"name": "站长工具",
					"href": "http://tool.chinaz.com/tools/jscodeconfusion.aspx",
					"title": ""
				}, {
					"name": "C在线工具",
					"href": "http://tool.oschina.net/",
					"title": ""
				}, {
					"name": "Less 编译",
					"href": "http://tool.oschina.net/less",
					"title": ""
				}, {
					"name": "图好快",
					"href": "http://www.tuhaokuai.com/",
					"title": "无需下载安装，一个让图片压缩更简单的在线工具！"
				}]
			}]
		}, {
			"id": "source",
			"title": "文档/资源库",
			"list": [{
				"tab": "前端文档",
				"item": [{
					"name": "HTML",
					"href": "http://www.runoob.com/tags/html-reference.html",
					"title": ""
				}, {
					"name": "CSS",
					"href": "http://www.runoob.com/cssref/css-reference.html",
					"title": ""
				}, {
					"name": "JavaScript",
					"href": "http://www.runoob.com/js/js-tutorial.html",
					"title": ""
				}, {
					"name": "JavaScript标准参考教程",
					"href": "http://javascript.ruanyifeng.com/",
					"title": ""
				}, {
					"name": "HTML5",
					"href": "https://www.w3.org/html/ig/zh/wiki/HTML5",
					"title": ""
				}, {
					"name": "CSS3",
					"href": "http://www.divcss5.com/css3/",
					"title": ""
				}, {
					"name": "JQuery",
					"href": "http://jquery.cuishifeng.cn/",
					"title": ""
				}, {
					"name": "AngularJS",
					"href": "http://www.apjs.net/",
					"title": ""
				}, {
					"name": "NodeJS",
					"href": "http://nodeapi.ucdok.com/",
					"title": ""
				}, {
					"name": "5+App",
					"href": "http://www.html5plus.org/doc/h5p.html",
					"title": ""
				}]
			}, {
				"tab": "静态资源库",
				"item": [{
					"name": "百度静态资源共享库",
					"href": "http://cdn.code.baidu.com/",
					"title": ""
				}, {
					"name": "BootCDN",
					"href": "http://www.bootcdn.cn/",
					"title": ""
				}]
			}, {
				"tab": "电子书",
				"item": [{
					"name": "看云",
					"href": "http://www.kancloud.cn/",
					"title": ""
				}, {
					"name": "爱思源",
					"href": "http://www.aseoe.com/webook/",
					"title": ""
				}, {
					"name": "脚本之家",
					"href": "http://www.jb51.net/books/",
					"title": ""
				}]
			}]
		}, {
			"id": "ui",
			"title": "UI设计",
			"list": [{
				"tab": "图标库",
				"item": [{
					"name": "Font Asesome",
					"href": "http://fontawesome.io/icons/",
					"title": ""
				}, {
					"name": "阿里矢量图",
					"href": "http://www.iconfont.cn/",
					"title": ""
				}, {
					"name": "ionicons",
					"href": "http://ionicons.com/",
					"title": ""
				}, {
					"name": "iconmoon",
					"href": "https://icomoon.io/",
					"title": ""
				}, {
					"name": "iconfinder",
					"href": "https://www.iconfinder.com/",
					"title": ""
				}]
			}, {
				"tab": "素材下载",
				"item": [{
					"name": "千图网",
					"href": "http://www.58pic.com/",
					"title": ""
				}, {
					"name": "17素材",
					"href": "http://www.17sucai.com/",
					"title": ""
				}, {
					"name": "站长素材",
					"href": "http://sc.chinaz.com/",
					"title": ""
				}, {
					"name": "懒人之家",
					"href": "http://www.lanrenzhijia.com/",
					"title": ""
				}, {
					"name": "6m5m",
					"href": "http://www.6m5m.com/",
					"title": "游戏素材资源平台"
				}]
			}, {
				"tab": "交互/思维导图",
				"item": [{
					"name": "processon",
					"href": "http://www.processon.com/",
					"title": "ProcessOn是一个方便易用、免费高效的在线作图工具"
				}]
			}]
		}]
	},
	init: function() {
		utils.navigation.create();
		utils.navigation.pageEvent();
		utils.navigation.clickTab();
		utils.navigation.hover();
	},
	create: function() {
		var main = utils.navigation.data.main;
		var tab = "";
		$.each(main, function(k, v) {
			var list = v.list;
			tab += '<li><a>' + v.title + '</a></li>';
			var section = '<section class="nav-list">';
			section += '<h4 class="nav-list-title">' + v.title + '</h4>';
			$.each(list, function(key, classify) {
				var item = classify.item;
				section += '<div class="nav-list-main">';
				section += '<div class="nav-classify">';
				section += '<div class="nav-classify-tab">' + classify.tab + '</div>';
				section += '<div class="nav-classify-content"><div class="nav-classify-bg"><div class="line"></div></div>';
				$.each(item, function(ik, iv) {
					section += '<div class="nav-classify-item" data-intro="' + iv.title + '"><a target="_blank" href="' + iv.href + '">' + iv.name + '</a></div>';
				});
				section += '</div>';
				section += '</div></div>';
			});
			section += '</section>';
			$(".nav-content").append(section);
		});
		$(".nav-aside ul").append(tab);
	},
	pageEvent: function() {
		$(document).on("mouseover", ".nav-classify-content", function(e) {
			$(this).addClass("active");
			e.stopPropagation();
		}).on("mouseout", ".nav-classify-content", function(e) {
			$(this).removeClass("active");
			e.stopPropagation();
		});
		var userAngent = null;
		if(/AppleWebKit.*Mobile/i.test(navigator.userAgent) || (/MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent))) {
			try {
				if(/Android|Windows Phone|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
					userAngent = "mobile";
				} else if(/iPad/i.test(navigator.userAgent)) {
					userAngent = "ipad"
				}
				isMobile = true;
			} catch(e) {}
		} else {
			isMobile = false;
			userAngent = "window";
		};
		if(!isMobile) {
			$(window).on("scroll", function() {
				var wTop = $(this).scrollTop();
				var nTop = 110;
				if(wTop >= nTop) {
					$(".nav-aside").css({
						"top": "45px"
					});
				} else {
					$(".nav-aside").css({
						"top": nTop + "px"
					});
				};
			});
		} else {
			$('.mobile-navs').on('click', function() {
				$(".nav-aside").css({
					"transform": "translate(0, 0)"
				});
			});
		}
	},
	clickTab: function() {
		var tab = $(".nav-aside>ul>li");
		var section = $(".nav-list");
		var wHeight = window.innerHeight;
		$(document).on("click", ".nav-aside>ul>li", function() {
			var index = $(this).index();
			var sTop = section.eq(index).offset().top;
			sTop = isMobile ? sTop - 55 : sTop;
			$("body,html").animate({
				scrollTop: sTop + "px"
			}, 1000);
		});
	},
	hover: function() {
		$(document).on("mouseover", ".nav-classify-item", function(e) {
			var intro = $(this).attr("data-intro");
			var top = $(this).offset().top - $(this).height() - 10;
			var left = $(this).offset().left + $(this).innerWidth() / 2;
			if(intro != "") {
				var grumble = '<div class="grumble" style="top:' + top + 'px;left:' + left + 'px;">' + intro + '</div>';
				$("body").append(grumble);
			};
			e.stopPropagation();
		}).on("mouseout", ".nav-classify-item", function(e) {
			$(".grumble").remove();
			e.stopPropagation();
		});
	}
};
$(function() {
	utils.navigation.init();
});